module.exports = __webpack_public_path__ + "static/media/cookie.4ba8ced6.svg";